// client/platform.js — browser bugs we work around.

const params = new URLSearchParams(location.search);

/** Health checks: use the iPhone (iOS 27) microphone settings in any browser (?test&ios27). */
export const FORCE_IOS27 = params.has("test") && params.has("ios27");

/**
 * True on iPhone/iPad with iOS 27 or later. There, any sound the page plays
 * crackles while a microphone with echo cancellation is open (WebKit bug
 * 326286, new in iOS 27; iOS 18 is clean). Audio calls on these devices open
 * the microphone without echo cancellation. Remove once Apple ships a fix.
 */
export function crackleWorkaround(ua = navigator.userAgent, touchPoints = navigator.maxTouchPoints) {
  const ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && touchPoints > 1);
  if (!ios) return false;
  // Safari 26+ reports iOS 18 in its user agent; its Version/ is the iOS
  // major. Other iOS browsers report the real OS version.
  const v = ua.match(/Version\/(\d+)/) ?? ua.match(/OS (\d+)_/);
  return !!v && Number(v[1]) >= 27;
}
